import { Subject } from 'rxjs';
import type { i18n } from './i18n/i18n';

export type TranslationKey = Parameters<typeof i18n>[0];
export type TranslationOptions = Parameters<typeof i18n>[1];
export const ariaLive = new Subject<
  { key: TranslationKey; options?: TranslationOptions } | undefined
>();

export const pushAria = (key: TranslationKey, options?: TranslationOptions) => {
  ariaLive.next({ key, options });
  setTimeout(() => {
    ariaLive.next(undefined);
  }, 500);
};
